import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import history from '../../helpers/history';

import { Layout, PageHeader, Select, AutoComplete, Button, Input, Form, DatePicker, Divider, Spin, Icon, Checkbox, Modal, Progress, message } from 'antd';
import moment, { max } from 'moment';

import OptimalGridResult from './OptimalGridResult';

import emitter from '../Evt.js';

import TooltipPage from '../../pannels/account/TooltipPage';

var moment_timezone = require('moment-timezone');

const { Option } = Select;

const { Content } = Layout;

var languageMessages = window.appLocale.messages;

function strReplace(source, jsonObjcet) {
    for (var v in jsonObjcet) {
        source = source.replace(v, jsonObjcet[v]);
    }
    return source;
}

function guid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

class OptimalGridPage extends Component {
    constructor(props) {
        super(props);

        window.webType === 'US' ? moment_timezone.tz.setDefault("America/New_York") : moment_timezone.tz.setDefault("Asia/Shanghai");

        this.user = {};
        this.state = {
            keywords: '',
            symbolItems: [],

            symbolCode: '',
            symbolName: '',

            latestPrice: 0,
            quoteChange: 0,

            lastTimes: 0,

            spinLoadding: true,
            
            upper: '',
            lower: '',

            startDate: moment().add(-15, 'days').format('YYYY-MM-DD'),
            endDate: moment().add(-1, 'days').format('YYYY-MM-DD'),

            tradeDateStatus: '',
            tradeDateMessage: '',

            priceRangeStatus: '',
            priceRangeMessage: '',

            endOpen: false,

            IsStartBacktest: false,

            dayTradeOnly: false,

            filterError: '',

            backtestStatus: 0,
            
            statisticsResult: [],

            consuming: 0,
            percent: 0,

            isHubConnection: 0,
        };
    }

    componentDidMount() {
        emitter.addListener('initPage', this.init);
        emitter.addListener("callSendBacktestError", this.callSendBacktestError);
        emitter.addListener("callOptimalGridError", this.callBacktestError);
        emitter.addListener('callOptimalGridLastTimes', this.callBacktestLastTimes);
        emitter.addListener('callOptimalGridStatus', this.callBacktestStatus);
        emitter.addListener('callOptimalGridResult', this.callBacktestResult);
    }

    componentWillMount() {
        this.init();
    }

    componentWillUnmount() {
        emitter.removeListener('initPage', this.init);
        emitter.removeListener('callSendBacktestError', this.callSendBacktestError);
        emitter.removeListener('callOptimalGridError', this.callBacktestError);
        emitter.removeListener('callOptimalGridLastTimes', this.callBacktestLastTimes);
        emitter.removeListener('callOptimalGridStatus', this.callBacktestStatus);
        emitter.removeListener('callOptimalGridResult', this.callBacktestResult);
    }

    callSendBacktestError = () => {
        this.setState({ spinLoadding: false });
    }

    callBacktestError = (status) => {
        var error = status !== undefined ? strReplace(languageMessages['backtestFail'], { '{num}': status }) : '';
        this.setState({ spinLoadding: false, filterError: error });
    }

    callBacktestLastTimes = (lastTimes, permission) => {
        if (this.user.permission !== undefined) {
            this.user.permission = permission;
            sessionStorage.setItem("auth", JSON.stringify(this.user));
        }

        this.setState({ lastTimes, backtestStatus: 1, spinLoadding: false });
    }

    keepDecimals(value, sign) {
        value = value == null ? '' : value;
        if (value !== '') {
            if (value > 0) {
                value = value.replace(/([0-9]+.[0-9]{2})[0-9]*/, "$1");
            }
            value += sign;
        }

        return value;
    }

    callBacktestStatus = (backtestStatus) => {
        backtestStatus = JSON.parse(backtestStatus || '{}');

        var consuming = parseInt(backtestStatus['consuming']);
        var percent = parseInt(backtestStatus['percent']);
        var backtestStatus = percent > 0 ? 2 : 1;

        this.setState({ backtestStatus, consuming, percent, spinLoadding: false });
    }

    callBacktestResult = (backtestResult, backtest) => {
        backtestResult = JSON.parse(backtestResult || '[]');

        var statisticsResult = [];
        
        if (backtestResult.length > 0) {
            
            for (var item in backtestResult) {
                var br = backtest.GridStrategys.filter(function (e) { return e.BacktestId === backtestResult[item]['backtestId']; });
                if (br[0].StrategyName.indexOf('strategy') == -1) continue;

                //var strategyName = backtestResult[item]['strategyName'];
                //var backtestInfo = strategyName.split('-');
                //if (backtestInfo.length < 6) continue;
                //if (backtestInfo[0] !== 'E') continue;
                
                //var gridCnt = backtestInfo[6];
                //var lower = backtest.Lower;
                //var upper = backtest.Upper;

                //let tmpGridCnt = parseInt(gridCnt);
                //var tmpLower = parseFloat(lower);
                //var tmpUpper = parseFloat(upper);
                
                //let gridWidth = (tmpUpper - tmpLower) / tmpGridCnt;

                var trades = backtestResult[item]['trades'];
                for (var ii in trades) {
                    trades[ii]['backtestId'] = backtestResult[item]['backtestId'];
                    trades[ii]['symbol'] = backtestResult[item]['symbol'];
                }

                statisticsResult.push({
                    backtestId: backtestResult[item]['backtestId'],
                    strategyName: br[0].StrategyName,

                    symbol: backtest.SymbolCode,
                    symbolName: backtest.SymbolName,
                    d: backtest.DayTradeOnly,

                    priceRange: '',//tmpLower.toFixed(2) + "~" + tmpUpper.toFixed(2),
                    gridCnt: br[0].GridCnt,
                    gridWidth: '',//gridWidth.toFixed(2),

                    capital: br[0].Capital,

                    initialRateOfReturnOnCapital: backtestResult[item]['statistics'].initialRateOfReturnOnCapital,
                    annualizedRateOfReturn: backtestResult[item]['statistics'].annualizedRateOfReturn,

                    //totalPnl: backtestResult[item]['statistics'].totalPnl,

                    profitFactor: backtestResult[item]['statistics'].profitFactor,

                    //maxDrawdown: backtestResult[item]['statistics'].maxDrawdownPercent,
                    //totalTrades: backtestResult[item]['statistics'].totalTrades,

                    equityCurve: backtestResult[item]['equityCurve'],
                    trades: trades
                });
            }
        }
        
        this.setState({ backtestStatus: 3, statisticsResult, spinLoadding: false, percent: 100 });
    }

    init = () => {
        this.user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};
        /**
        if (user.username === undefined) {
            this.setState({ spinLoadding: false }, () => {
                this.props.dispatch({ type: "action_non_user" });
            });
        } else {
            this.props.dispatch({ type: "action_get_luis_sectors", payload: { UserId: user.username, stockPoolKey: this.state.stockPoolKey, stockGroups: this.state.stockGroups } });
        }
        */

        var userId = this.user.username === undefined ? '' : this.user.username;
        this.props.dispatch({ type: "action_get_explore_grid", payload: { u: userId } });
    }

    setUserPermission(permissions) {
        var lastTimes = 0;
        for (var key in permissions) {
            var permission = permissions[key];
            switch (permission.type) {
                case 'egs':
                    lastTimes += permission.totalCount - permission.usageCount;
                    break;
                default:
                    lastTimes += 0;
                    break;
            }
        }
        this.setState({ lastTimes });
    }

    componentWillReceiveProps(props) {
        var { status, symbolItems, permission, uri, state } = props;

        switch (status) {
            case 'get_explore_grid_success':
                if (this.user.permission !== undefined) {
                    this.user.permission = permission;
                    sessionStorage.setItem("auth", JSON.stringify(this.user));
                    this.setUserPermission(this.user.permission);
                }

                this.setState({ spinLoadding: false });
                break;
            case 'get_explore_grid_fail':

                this.setState({ spinLoadding: false });
                break;
            case 'get_symbol_items_success':
                if (symbolItems !== undefined && symbolItems.length > 0) {
                    this.setState({ symbolItems });
                } else {
                    if (this.state.keywords !== '') {
                        this.setState({ symbolItems: [{ symbol: '"' + this.state.keywords + '"' + languageMessages['no.matches.found'], symbolName: '' }] });
                    } else {
                        this.setState({
                            symbolItems: []
                        });
                    }
                }
                break;
            case 'get_auth_success':
                const w = window.open('about:blank');
                w.location.href = uri;

                break;
            case 'get_auth_failed':
                if (state == 3) message.info(languageMessages['Authentication is normal']);
                else message.info(languageMessages['Failed to get auth url']);
                break;
            default:
                this.setState({ spinLoadding: false });
                break;
        }
    }

    handleMyBacktest = e => {
        e.preventDefault();

        history.push("/mbg");
    };

    onChangeSymbol = (symbolCode) => {
        var IsStartBacktest = this.checkIsStartBacktest('symbolCode', '');

        this.setState({ symbolCode, IsStartBacktest, filterError: '' });
    }

    // 选择标的
    onSelectSymbol = value => {
        if (value !== '') {
            if (value.search(languageMessages['no.matches.found']) === -1) {
                //languageMessages['no.matches.found']

                //var symbolItems = JSON.parse(sessionStorage.getItem("SymbolItemsCache") || '[]') || [];
                //var tmpDataCode = symbolItems.filter(function (e) { return e.stockCode.toLowerCase() === value.toLowerCase(); });
                var tmpDataCode = this.state.symbolItems.filter(function (e) { return e.symbol.toLowerCase() === value.toLowerCase(); });

                if (tmpDataCode.length > 0) {
                    var symbolCode = tmpDataCode[0].symbol;
                    var symbolName = tmpDataCode[0].symbolName;
                    var latestPrice = parseFloat(tmpDataCode[0].close).toFixed(2);
                    var quoteChange = parseFloat(tmpDataCode[0].chg).toFixed(2);

                    var IsStartBacktest = this.checkIsStartBacktest('symbolCode', symbolCode);

                    this.setState({ symbolCode, symbolName, latestPrice, quoteChange, IsStartBacktest, filterError: '' });
                }
            }
        }
    }

    onFocusSymbol = () => {
        // defaylt symbol items
    }

    onBlurSymbol = value => {
        if (value !== '') {
            var tmpDataCode = this.state.symbolItems.filter(function (e) { return e.symbol.toLowerCase() === value.toLowerCase(); });

            if (tmpDataCode.length === 0) {
                tmpDataCode = this.state.symbolItems.filter(function (e) { return e.symbol.substring(2, e.symbol.length) === value; });
            }

            if (tmpDataCode.length === 1) {
                var symbolCode = tmpDataCode[0].symbol;
                var symbolName = tmpDataCode[0].symbolName;
                var latestPrice = parseFloat(tmpDataCode[0].close).toFixed(2);
                var quoteChange = parseFloat(tmpDataCode[0].chg).toFixed(2);

                var IsStartBacktest = this.checkIsStartBacktest('symbolCode', symbolCode);

                this.setState({ symbolCode, symbolName, latestPrice, quoteChange, IsStartBacktest, filterError: '' });
            } else {
                var IsStartBacktest = this.checkIsStartBacktest('symbolCode', '');

                this.setState({
                    symbolItems: [],
                    symbolCode: '',
                    symbolName: '',
                    latestPrice: 0,
                    quoteChange: 0,
                    filterError: '',
                    IsStartBacktest
                });
            }
        } else {
            var IsStartBacktest = this.checkIsStartBacktest('symbolCode', '');

            this.setState({
                symbolItems: [],
                symbolCode: '',
                symbolName: '',
                latestPrice: 0,
                quoteChange: 0,
                filterError: '',
                IsStartBacktest
            });
        }
    }

    // 匹配标的
    handleSearch = value => {
        this.setState({ keywords: value, filterError: '' }, () => {
            this.props.dispatch({ type: "action_get_symbol_items", payload: { UserId: this.user.username, keywords: value } });
        });
    };

    //开始日期
    onChangeStartDate = startDate => {
        startDate = moment(startDate).format("YYYY-MM-DD");

        //判断小于结束时间
        /** 
        var oDate1 = new Date(startDate);
        var oDate2 = new Date(endDate);
        if (oDate1.getTime() < oDate2.getTime()) {
            
        }
        */

        var IsStartBacktest = this.checkIsStartBacktest('startDate', startDate);

        this.setState({ startDate, IsStartBacktest, filterError: '' });
    }
    
    //结束日期
    onChangeEndDate = endDate => {
        endDate = moment(endDate).format("YYYY-MM-DD");

        var tradeDateStatus = '';
        var tradeDateMessage = '';
        
        var oDate1 = new Date(this.state.startDate);
        var oDate2 = new Date(endDate);

        var intDate1 = oDate1.getTime();
        var intDate2 = oDate2.getTime();
        if (intDate1 > intDate2) {
            tradeDateStatus = 'error';
            tradeDateMessage = languageMessages['startDateGreaterThanEndDate'];
        }

        var IsStartBacktest = this.checkIsStartBacktest('endDate', endDate);

        this.setState({ endDate, IsStartBacktest, tradeDateStatus, tradeDateMessage, filterError: '' });
    }

    todayDisabledDate = current => {
        const { endDate } = this.state;
        if (!endDate) {
            return false;
        }
        return current && (current > moment(endDate) || current < moment(endDate).add(-6, 'months'));
    }

    endDisabledDate = current => {
        const { startDate } = this.state;
        if (!startDate) {
            return false;
        }
        return current && (current < moment(startDate) || current > moment().add(-1, 'days'));
    }

    handleStartOpenChange = open => {
        if (!open) {
            this.setState({ endOpen: true, filterError: '' });
        }
    };

    handleEndOpenChange = endOpen => {
        var tradeDateStatus = '';
        var tradeDateMessage = '';

        if (!endOpen) {
            //判断日期是否小于开始日期
            var oDate1 = new Date(this.state.startDate);
            var oDate2 = new Date(this.state.endDate);

            var intDate1 = oDate1.getTime();
            var intDate2 = oDate2.getTime();
            if (intDate1 > intDate2) {
                tradeDateStatus = 'error';
                tradeDateMessage = languageMessages['startDateGreaterThanEndDate'];
            }
        }

        this.setState({ endOpen, tradeDateStatus, tradeDateMessage, filterError: '' });
    };

    handleNumberChange = e => {
        let intLen = 12;
        let decimalLen = 2;

        var number = e.target.value;
        let tags = e.currentTarget.getAttribute('data-value');
        if (tags === 'lower' || tags === 'upper') {
            decimalLen = 3;
        }

        if (number.indexOf('.') === 0) {
            number = number.replace(/[^\d]/g, "");
        }
        number = number.replace(/[^\d.]/g, "");
        number = number.replace(/\.{2,3}/g, ".");
        number = number.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");

        if (number.indexOf('.') < 0) {
            if (number.length > intLen) number = number.slice(0, intLen);

            if (number !== '') number = parseInt(number);
        } else {
            var tmpNumber = number.split('.');
            var tmpNum00 = tmpNumber[0];
            if (tmpNum00.length > intLen) tmpNum00 = tmpNum00.slice(0, intLen);

            if (tmpNum00 !== '') tmpNum00 = parseInt(tmpNum00);

            var tmpNum01 = tmpNumber[1];
            if (tmpNum01.length > decimalLen) tmpNum01 = tmpNum01.slice(0, decimalLen);
            number = tmpNum00 + '.' + tmpNum01;
        }

        this.checkInputParamsStatus(tags, number);
    }

    onBlurNumberChange = e => {
        e.preventDefault();

        var number = e.target.value;
        var tags = e.currentTarget.getAttribute('data-value');
        if (tags === 'lower' || tags === 'upper') {
            if (number.length > 0) {
                if (number.indexOf('.') < 0) {
                    number = number + '.000';
                } else {
                    var tmpValue = number.split('.');
                    var len = tmpValue[1].length;
                    if (len === 0) {
                        number = number + '000';
                    } else if (len === 1) {
                        number = number + '00';
                    } else if (len === 2) {
                        number = number + '0';
                    }
                }
            }
        } else {
            if (number.length > 0) {
                if (number.indexOf('.') < 0) {
                    number = number + '.00';
                } else {
                    var tmpValue = number.split('.');
                    var len = tmpValue[1].length;
                    if (len === 0) {
                        number = number + '00';
                    } else if (len === 1) {
                        number = number + '0';
                    }
                }
            }
        }

        this.checkInputParamsStatus(tags, number);
    }

    checkInputParamsStatus(tags, number) {
        let { lower, upper } = this.state;

        let priceRangeStatus = '';
        let priceRangeMessage = '';

        if (tags === 'lower') {
            if (upper != '' && number != '') {
                let tmpUpper = parseFloat(upper);
                let tmpLower = parseFloat(number);
                if (tmpLower >= tmpUpper) {
                    priceRangeStatus = 'error';
                    priceRangeMessage = languageMessages['lowestPriceCannotBeGreaterThanHighestPrice'];
                }
            }
        }

        if (tags === 'upper') {
            if (lower != '' && number != '') {
                let tmpUpper = parseFloat(number);
                let tmpLower = parseFloat(lower);
                if (tmpLower >= tmpUpper) {
                    priceRangeStatus = 'error';
                    priceRangeMessage = languageMessages['lowestPriceCannotBeGreaterThanHighestPrice'];
                }
            }
        }

        var tmpPrice = {};
        tmpPrice[tags] = number;

        tmpPrice['IsStartBacktest'] = this.checkIsStartBacktest(tags, number);

        tmpPrice['priceRangeStatus'] = priceRangeStatus;
        tmpPrice['priceRangeMessage'] = priceRangeMessage;
        tmpPrice['filterError'] = '';

        this.setState(tmpPrice);
    }

    handleChangeDayTradeOnly = e => {
        var dayTradeOnly = e.target.checked;

        this.setState({ dayTradeOnly });
    }

    checkIsStartBacktest(type, value) {
        var IsStartBacktest = false;
        let { symbolCode, startDate, endDate, lower, upper } = this.state;

        switch (type) {
            case 'symbolCode':
                symbolCode = value;
                break;
            case 'lower':
                lower = value;
                break;
            case 'upper':
                upper = value;
                break;
            case 'startDate':
                startDate = value;
                break;
            case 'endDate':
                endDate = value;
                break;
            default:
                break;
        }

        if (symbolCode != '' && lower != '' && upper != '') {
            var tmpLower = parseFloat(lower);
            var tmpUpper = parseFloat(upper);

            var oDate1 = new Date(startDate);
            var oDate2 = new Date(endDate);

            if (tmpUpper > tmpLower && oDate2.getTime() > oDate1.getTime()) {
                IsStartBacktest = true;
            }
        }

        return IsStartBacktest;
    }

    onStartBacktest = () => {
        if (this.user.username === undefined) {
            this.setState({
                filterError: '',
                spinLoadding: false,
            }, () => {
                this.props.dispatch({ type: "action_non_user" });
            });
        } else {
            let { symbolCode, symbolName, startDate, endDate, lastTimes, latestPrice, lower, upper, dayTradeOnly } = this.state;

            if (lastTimes <= 0) {
                var content = <span>{languageMessages['todayBacktestNumberRunOut']}，{languageMessages['please go']}<a onClick={this.onValueAddedServices}>{languageMessages['value-added.services']}</a></span>;
                Modal.info({
                    title: languageMessages['prompt'],
                    content: content
                });
                return;
            }

            this.setState({
                backtestStatus: 0,
                statisticsResult: [],
                consuming: 0,
                percent: 0,
                filterError: '',
                spinLoadding: true,
            }, () => {
                this.props.dispatch({
                    type: "action_send_hub_message", payload: {
                        service: 'SendBacktest', userId: this.user.username,
                        msg: {
                            Type: 'exploreGridStrategy',
                            SymbolCode: symbolCode,
                            SymbolName: symbolName,
                            StartDate: startDate,
                            EndDate: endDate,
                            Lower: lower,
                            Upper: upper,
                            DayTradeOnly: dayTradeOnly ? '1' : '0',
                            Last: latestPrice,
                            reqId: guid(),
                            CommType: 0,
                            MinComm: 0,
                            PerShareCommission: 0
                        }
                    }
                });
            });
        }
    }

    importBacktestResult = () => {
        //console.log('import');
    }

    render() {
        var { symbolItems, symbolCode, percent } = this.state;

        if (symbolCode.search(languageMessages['no.matches.found']) !== -1) {
            symbolCode = symbolCode.replace(languageMessages['no.matches.found'], '');
            symbolCode = symbolCode.substring(1, symbolCode.length - 1);
        }

        return (<Content className='main-container total-content'>
            <Helmet>
                <title>{languageMessages['title']}</title>
                <meta name="keywords" content={languageMessages['keywords']} />
                <meta name="description" content={languageMessages['description']} />

                <meta property="og:title" content={languageMessages['title']} />
                <meta property="og:url" content="https://us.quancept.com/" />
                <meta property="og:type" content="website" />
                <meta name="og:description" content={languageMessages['description']} />

                <meta property="twitter:url" content="https://us.quancept.com/" />
                <meta name="twitter:title" content={languageMessages['title']} />
                <meta name="twitter:description" content={languageMessages['description']} />
                <meta name="twitter:site" content="https://us.quancept.com/" />
            </Helmet>
            <Spin spinning={this.state.spinLoadding}>
                <div className='common-page-header'>
                    <PageHeader title={(<h1>{languageMessages['optimalGrid']}</h1>)} />
                </div>
                <div style={{ padding: '0px 50px', marginBottom: '20px' }}>
                    <div className='common-title'><Divider type="vertical" />{languageMessages['basic.info']}</div>
                    <div className='common-backtest-cont'>
                        <Form labelAlign={'left'} layout="inline" className={window.webType === 'US' ? 'common-form-hawkeye hawkeye-us' : 'common-form-hawkeye'}>
                            <Form.Item colon={false} label={languageMessages['symbolCode']} style={{ marginBottom: 0, marginRight: 32 }}>
                                <AutoComplete value={symbolCode}
                                    className="certain-category-search"
                                    dropdownClassName="certain-category-search-dropdown"
                                    dropdownMatchSelectWidth={false}
                                    dropdownStyle={{ width: 200 }}
                                    size="small"
                                    style={{ width: '200px' }}
                                    dataSource={symbolItems.map(group => (
                                        <Option key={group.symbol} value={group.symbol}>
                                            {group.symbol}
                                            <span className="certain-search-item-count">{group.symbolName}</span>
                                        </Option>
                                    ))}
                                    onChange={this.onChangeSymbol}
                                    onSearch={this.handleSearch}
                                    onSelect={this.onSelectSymbol}
                                    onFocus={this.onFocusSymbol}
                                    onBlur={this.onBlurSymbol}
                                    placeholder={languageMessages['pleaseEnterSymbolCode']}
                                    optionLabelProp="value">
                                    <Input suffix={<Icon type="search" className="certain-category-icon" />} />
                                </AutoComplete>
                                <div style={{ position: 'relative', top: '-5px', height: '20px', lineHeight: '20px', fontSize: '10px' }}>
                                    {languageMessages['latest.price']}：<span style={{ color: this.state.quoteChange === 0 ? 'rgba(0, 0, 0, 0.25)' : 'rgba(0, 0, 0, 0.85)', marginRight: '10px' }}>{this.state.latestPrice}</span>
                                    {languageMessages['quote.change']}：<span style={{ color: this.state.quoteChange === 0 ? 'rgba(0, 0, 0, 0.25)' : this.state.quoteChange >= 0 ? window.webType === 'US' ? 'green' : 'red' : window.webType === 'US' ? 'red' : 'green' }}>{this.state.quoteChange}%</span>
                                </div>
                            </Form.Item>
                        </Form>
                    </div>
                    <div className='common-title'><Divider type="vertical" />{languageMessages['gridSetting']}</div>
                    <div className='common-backtest-cont'>
                        <Form labelAlign={'left'} layout="inline" style={{ padding: '8px 0' }} className={window.webType === 'US' ? 'common-form-hawkeye hawkeye-us' : 'common-form-hawkeye'}>
                            <Form.Item colon={false} label={languageMessages['priceRange']} validateStatus={this.state.priceRangeStatus} help={this.state.priceRangeMessage}>
                                <Input type="text" size='small' style={{ width: 120 }} value={this.state.lower} onChange={this.handleNumberChange} onBlur={this.onBlurNumberChange} placeholder={languageMessages['lowestPriceRange']} data-value='lower' />
                                <span style={{ margin: '0 10px' }}>--</span>
                                <Input type="text" size='small' style={{ width: 120 }} value={this.state.upper} onChange={this.handleNumberChange} onBlur={this.onBlurNumberChange} placeholder={languageMessages['highestPriceRange']} data-value='upper' />
                            </Form.Item>
                        </Form>
                        <Form labelAlign={'left'} layout="inline" style={{ padding: '8px 0' }} className={window.webType === 'US' ? 'common-form-hawkeye hawkeye-us' : 'common-form-hawkeye'}>
                            <Form.Item>
                                <Checkbox checked={this.state.dayTradeOnly} onChange={this.handleChangeDayTradeOnly}>{languageMessages['DayTradeOnly']}</Checkbox>
                            </Form.Item>
                        </Form>
                    </div>
                    <div className='common-title'><Divider type="vertical" />{languageMessages['backtestCondition']}</div>
                    <div className='common-backtest-cont'>
                        <div style={{ marginBottom: '20px' }}>
                            <Form labelAlign={'left'} layout="inline" className={window.webType === 'US' ? 'common-form-hawkeye hawkeye-us' : 'common-form-hawkeye'}>
                                <Form.Item colon={false} label={languageMessages['backtestInterval']} validateStatus={this.state.tradeDateStatus} help={this.state.tradeDateMessage}>
                                    <span style={{ display: 'inline-block' }}>
                                        <DatePicker size="small"
                                            allowClear={false}
                                            placeholder={languageMessages['pleaseEnterStartDate']}
                                            value={moment(this.state.startDate, "YYYY-MM-DD")}
                                            disabledDate={this.todayDisabledDate}
                                            format={"YYYY-MM-DD"} style={{ width: '120px' }}
                                            onChange={this.onChangeStartDate}
                                            onOpenChange={this.handleStartOpenChange}
                                        />
                                    </span>
                                    <span style={{ display: 'inline-block', width: '24px', textAlign: 'center' }}>{languageMessages['intl.to']}</span>
                                    <span style={{ display: 'inline-block' }}>
                                        <DatePicker size="small"
                                            allowClear={false}
                                            placeholder={languageMessages['pleaseEnterEndDate']}
                                            value={moment(this.state.endDate, "YYYY-MM-DD")}
                                            disabledDate={this.endDisabledDate}
                                            format={"YYYY-MM-DD"} style={{ width: '120px' }}
                                            onChange={this.onChangeEndDate}
                                            disabled={this.state.startDate === ''}
                                            open={this.state.endOpen}
                                            onOpenChange={this.handleEndOpenChange}
                                        />
                                    </span>
                                </Form.Item>
                            </Form>
                        </div>
                        <Button size='small' loading={false} disabled={!this.state.IsStartBacktest} onClick={this.onStartBacktest}>
                            {languageMessages['startBacktest']}
                        </Button>
                        <TooltipPage lastTimes={this.state.lastTimes} filterError={this.state.filterError} />
                    </div>
                </div>
                <div style={{ backgroundColor: '#efefef', height: '48px', lineHeight: '48px', padding: '0 50px', display: this.state.backtestStatus > 0 ? 'block' : 'none' }}>
                    <div style={{ float: 'left' }}>
                        <b>{languageMessages['backtestStatus']}</b>
                        <span style={{ margin: '0 10px', display: this.state.backtestStatus == 1 ? 'inline-block' : 'none' }}>{languageMessages['queue']}</span>
                        <span style={{ display: this.state.backtestStatus == 2 ? 'inline-block' : 'none' }}>
                            <span style={{ margin: '0 10px' }}>{strReplace(languageMessages['backtestingConsuming'], { '{num}': this.state.consuming })}</span>
                            <span style={{ display: 'inline-block', width: '300px', margin: '0 10px' }}><Progress strokeColor={{ '0%': '#108ee9', '100%': '#87d068', }} percent={percent} /></span>
                        </span>
                        <span style={{ margin: '0 10px', display: this.state.backtestStatus == 3 ? 'inline-block' : 'none' }}>{strReplace(languageMessages['backtestCompletedConsuming'], { '{num}': this.state.consuming })}</span>
                    </div>
                    <div style={{ float: 'right' }}>
                        
                    </div>
                </div>
                <Content style={{ padding: '0px 50px', marginBottom: '50px' }}>
                    {this.state.statisticsResult.length == 0 || (<OptimalGridResult dispatch={this.props.dispatch} status={this.props.status} basePosition={this.props.basePosition} share={this.props.share} statisticsResult={this.state.statisticsResult} />)}
                </Content>
        </Spin>
    </Content>);
    }
}

function mapStateToProps(state) {
    return state.backtest;
}

const page = connect(mapStateToProps)(OptimalGridPage);
export { page as default }